import { useDispatch, useSelector } from "react-redux";
import PowerCard from "./PowerCard";
import { useEffect, useMemo, useState } from "react";
import { fetchDevices, fetchLatestReadings, fetchLiveDeviceReading } from "../../actions/liveMonitorActions";

function LiveMonitor() {
    const dispatch = useDispatch();

    const { devices, readings, loading } = useSelector(
        (state) => state.liveMonitor
    );

    const [search, setSearch] = useState("");
    const [deviceType, setDeviceType] = useState("GENERATOR");

    // useEffect(() => {
    //     dispatch(fetchDevices());

    //     dispatch(fetchLatestReadings());

    //     const interval = setInterval(() => {
    //         dispatch(fetchLatestReadings());
    //     }, 60000);

    //     return () => clearInterval(interval);
    // }, [dispatch]);

    useEffect(() => {
        dispatch(fetchDevices());
    }, [dispatch])

    useEffect(() => {
        if (!devices.length) return;

        const loadLiveReadings = () => {
            devices.forEach((device) => {
                dispatch(
                    fetchLiveDeviceReading(device.DeviceCode)
                )
            })
        }

        loadLiveReadings();

        const interval = setInterval(
            loadLiveReadings, 30000
        )

        return () => clearInterval(interval)
    }, [dispatch, devices]);

    const filteredDevices = useMemo(() => {
        let filtered = [...devices];

        // Only show devices with a live reading
        filtered = filtered.filter(
            (device) => readings[device.DeviceCode]
        );

        // Search
        if (search) {
            filtered = filtered.filter((device) => {
                return device.DeviceCode?.toLowerCase().includes(search.toLowerCase())
            })
        };

        // Type filter
        if (deviceType === "POWER_PANEL") {
            filtered = filtered.filter(
                (device) => device.DeviceType === "P"
            );
        }

        if (deviceType === "GENERATOR") {
            filtered = filtered.filter(
                (device) => device.DeviceType === "G"
            )
        }

        filtered.sort((a, b) => {
            const readingA = readings[a.DeviceCode];
            const readingB = readings[b.DeviceCode];

            const timestampA = new Date(
                `${readingA.Ddate}T${readingA.Dtime}`
            ).getTime();

            const timestampB = new Date(
                `${readingB.Ddate}T${readingB.Dtime}`
            ).getTime();

            const onlineA = (Date.now() - timestampA) / 1000 <= 180;

            const onlineB = (Date.now() - timestampB) / 1000 <= 180;

            // Online first
            return Number(onlineB) - Number(onlineA);
        });

        return filtered
    }, [devices, readings, search, deviceType]);

    return (
        <div className="flex flex-col gap-6">
            {/* Filters */}
            <div className="flex flex-col md:flex-row gap-4">
                <input 
                    type="text"
                    placeholder="Search Device ID..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="flex-1 p-3 md:px-4 md:py-3 rounded-xl border border-border focus:border-electricBlue outline-none"
                />

                {/* <select
                    value={deviceType}
                    onChange={(e) => setDeviceType(e.target.value)}
                    className="border px-4 py-2 rounded-lg"
                >

                    <option value="GENERATOR">Generator</option>
                    <option value="POWER_PANEL">Power Panel</option>
                </select> */}

                <div className="flex rounded-xl bg-white p-1 border border-border">
                    <button
                        onClick={() => setDeviceType("GENERATOR")}
                        className={`
                            flex-1 md:flex-none px-5 py-2 rounded-lg transition
                            ${
                                deviceType === "GENERATOR" ? "bg-deepNavy text-white" : "text-slate-500"
                            }  
                        `}
                    >
                        Generators
                    </button>

                    <button
                        onClick={() => setDeviceType("POWER_PANEL")}
                        className={`
                            flex-1 md:flex-none px-5 py-2 rounded-lg transition
                            ${
                                deviceType === "POWER_PANEL" ? "bg-deepNavy text-white" : "text-slate-500"
                            }  
                        `}
                    >
                        Power Panels
                    </button>
                </div>
            </div>

            {/* Cards */}
            {loading ? (
                <div className="text-center text-slate-600 p-12">
                    Loading devices...
                </div>
            ) : (
                <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
                    {filteredDevices.length === 0 ? (
                        <div className="col-span-full text-center text-slate-600 p-12">
                            No {deviceType === "GENERATOR" ? "generators" : "power panels"} found.
                        </div>
                    ) : (
                        filteredDevices.map((device) => (
                            <PowerCard 
                                key={`${device.DeviceCode}`}
                                deviceId={device.DeviceCode}
                            />
                        ))
                    )}
                </div>
            )}
        </div>
    );
}

export default LiveMonitor;